import { z } from 'zod';

export const SendAsIdentityInput = z.object({
  email: z.email().max(320),
  name: z.string().trim().max(200).regex(/^[^\r\n]*$/),
  envelopeFrom: z.enum(['account', 'identity']),
});
export const SendAsIdentity = SendAsIdentityInput.extend({ id: z.uuid() });
export type SendAsIdentity = z.infer<typeof SendAsIdentity>;
export const SendAsIdentityCreate = SendAsIdentityInput.extend({
  currentPassword: z.string().min(1).max(1024),
});

export const MailTemplateInput = z.object({
  name: z.string().trim().min(1).max(100),
  subject: z.string().max(998),
  bodyHtml: z.string().max(100_000),
  bodyText: z.string().max(100_000),
});
export type MailTemplateInput = z.infer<typeof MailTemplateInput>;
export const MailTemplate = MailTemplateInput.extend({
  id: z.number().int().positive(),
  revision: z.number().int().positive(),
});
export type MailTemplate = z.infer<typeof MailTemplate>;
export const MailTemplateUpdate = MailTemplateInput.extend({ revision: z.number().int().positive() });
